module.exports = __webpack_public_path__ + "static/img/5.8b4f67a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/5.png
// module id = +/tE
// module chunks = 0